// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.product-img[data-v-350c0a46]{\n    width: 150px;\n    height: 65px;\n    object-fit: cover;\n}\n", ""]);
// Exports
module.exports = exports;
